'use client';

import { MapPin } from 'lucide-react';
import { Button } from '@/app/_components/core/button';
import type { ConsentPlaceholderProps } from '@/app/_components/shared/location-map/location-map.types';
import { cn } from '@/app/_lib/utils';

const ASPECT_RATIO_CLASS = 'aspect-10/16 md:aspect-16/10';

export function ConsentPlaceholder({ labels, onOpenConsent, trackingPrefix }: ConsentPlaceholderProps) {
  const title = labels?.consentTitle;
  const description = labels?.consentDescription;
  const buttonLabel = labels?.consentButton;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 bg-muted',
        ASPECT_RATIO_CLASS
      )}
    >
      <MapPin className="size-12  text-muted-foreground" />

      <div className="px-4 text-center">
        <p className="mb-2 text-lg font-medium">{title}</p>
        <p className="mb-4 max-w-md text-sm text-muted-foreground">
          {description}
        </p>
        <Button
          onClick={onOpenConsent}
          variant="default"
          className="cursor-pointer"
          data-track-id={trackingPrefix ? `${trackingPrefix}-consent` : undefined}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}
